function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3 21c-.552 0-1-.448-1-1V8c0-.552.448-1 1-1h5v-.355c0-1.926 1.401-3.534 3.211-3.64L11.4 3h1.2c1.837 0 3.3 1.544 3.395 3.447l.005.198V7h5c.513 0 .936.386.993.883L22 8v12c0 .552-.448 1-1 1zM8 8.999L4 9v10l4-.001v-10zm6 0h-4v10h4v-10zM20 9l-4-.001v10L20 19V9zm-7.4-4h-1.2c-.709 0-1.328.639-1.394 1.492L10 6.645V7h4v-.355c0-.878-.58-1.565-1.276-1.638L12.6 5z"
});

var SvgService = function SvgService(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgService, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/service.73ee67db.svg";
export { ForwardRef as ReactComponent };